import { createAsyncThunk } from '@reduxjs/toolkit';
import dashboardService from '../../services';

export const regenerateAiContent = createAsyncThunk(
  'product/regenerateAiContent',
  dashboardService.regenerateAiContent,
);
